import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  mb, px, pt, pb, my, mt, pr
} from 'styled-components-spacing';

import {
  SecondOpinionIcon,
  TreatmentAbroad,
  PMT,
  Expand,
  Collapse
} from '@images/svg';

export const StyledCoverMaxWidthWrapper = styled.div`
   max-width: 1200px;
   margin: auto;
  position: relative;
  ${pb(4)}
  ${breakpoint('desktop')`
    ${px(3)}
    ${mb(4)}
  `}
  ${breakpoint('mobile', 'tablet')`
    padding: 10px;
  `}
  @media (min-width: 550px) and (max-width: 736px){
    max-width: 550px;
    margin: auto;
  }
  @media (min-width: 736px) and (max-width:1024px){
    max-width: 700px;
    margin: auto;
  }
`;
export const StyledCover = styled.div`
  background-color: #F2FDFF;
  width: 100%;
  ${pt(4)}

`;

export const StyledCard = styled.div`
  border-radius: 20px;
  border: 1px solid #0A537A;
  padding: 25px;
  ${my(3)}
  ${breakpoint('mobile', 'tablet')`
    padding:15px;
  `}
`;

export const StyledHeadingTab = styled.div`
  font-size: 25px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${breakpoint('mobile', 'tablet')`
    font-size: 17px;
    `}
`;

export const StyledCardContent = styled.div`
  font-size: 25px;
  font-weight: 500;
  display: flex;
  line-height: 1.2;
  ${mt(4)}
  /* ${({ hover }) => !hover
  && `
    display:none;
  `} */

  ${breakpoint('mobile', 'tablet')`
    font-size: 18px;
    ${mt(3)}
    flex-direction: column-reverse;
    ${({ hover }) => !hover
  && `
    display:none !important;
  `}
  `}

  ${({ hover }) => !hover
  && `
    display:none !important;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 20px;
    line-height: 1.2;
    ${mt(3)}
  `}
`;

export const StyledSecondOpinionIcon = styled(SecondOpinionIcon)`
  width: 40px;
  height: 40px;
  path{
    fill: #0A537A;
  }
  ${breakpoint('mobile', 'tablet')`
    width: 30px;
    height: 30px;
  `}
`;

export const StyledTreatmentAbroad = styled(TreatmentAbroad)`
  width: 40px;
  height: 40px;
  ${breakpoint('mobile', 'tablet')`
    width: 30px;
    height: 30px;
  `}
`;

export const StyledPMT = styled(PMT)`
  width: 40px;
  height: 40px;
  ${breakpoint('mobile', 'tablet')`
    width: 30px;
    height: 30px;
  `}
`;

export const StyledHeading = styled.h3`
  display: flex;
  align-items: center;
  ${px(2)}
`;

export const StyledCollapsseIcon = styled(Collapse)`
  width: 25px;
  height: 5px;
  ${breakpoint('mobile', 'tablet')`
    width: 20px;
    height: 5px;
  `}
`;

export const StyledExpandIcon = styled(Expand)`
  width: 25px;
  height: 25px;
  ${breakpoint('mobile', 'tablet')`
    width: 20px;
    height: 20px;
  `}
`;

export const StyledImage = styled.img`
  height: 300px;
  ${breakpoint('mobile', 'tablet')`
  height: auto;
  ${({ pms }) => pms && `
    object-fit:contain;
    height: 300px;
  `}
  `}
  ${breakpoint('tablet', 'desktop')`
    height: 200px;
  `}
`;

export const StyledContent = styled.div`
  ${pr(3)};
  ${breakpoint('mobile', 'tablet')`
  ${pr(0)}
   ${pt(3)}
  `}
`;

export const StyledText = styled.h2`
  padding-left: 5px;
`;

export const StyledMainHeading = styled.h1`
  font-size: 30px;
  text-align: center;
  font-weight: 700;
  ${breakpoint('mobile', 'tablet')`
     font-size: 22px;
  `}
`;
